import DoneIcon from 'assets/icons/done-icon.svg';
import WarnningIcon from 'assets/icons/warnning-red-icon.svg';
import { DESKTOP_MIN_WIDTH, RESET_PASSWORD_PASSWORD_NAME } from 'constants';
import {
  leastLowercaseValid,
  leastOneNumberValid,
  leastUppercaseValid,
  lengthIs8Valid,
} from 'helpers';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import HiddenIcon from '../../../../assets/icons/eye-hidden-icon.svg';
import ShowIcon from '../../../../assets/icons/eye-show-icon.svg';

const FormInputValidation = ({
  field,
  information,
  setInformation,
  validation,
  setValidation,
  setLiveCheckStatus,
}) => {
  const { t } = useLang();

  const [isShowPassword, setShowPassword] = useState(false);

  const handlePasswordLiveCheck = (value) => {
    return {
      0: lengthIs8Valid(value) ? DoneIcon : WarnningIcon,
      1: leastOneNumberValid(value) ? DoneIcon : WarnningIcon,
      2: leastLowercaseValid(value) ? DoneIcon : WarnningIcon,
      3: leastUppercaseValid(value) ? DoneIcon : WarnningIcon,
    };
  };

  const handleOnChange = (e) => {
    const { value, name } = e.target;
    const valueTrim = value.trim();

    const newInformation = {
      ...information,
      [name]: valueTrim,
    };
    setInformation(newInformation);

    if (name === RESET_PASSWORD_PASSWORD_NAME) {
      const newLiveCheckStatus = handlePasswordLiveCheck(value);
      setLiveCheckStatus(newLiveCheckStatus);
    }
  };

  const handleOnFocus = (e) => {
    const { name } = e.target;

    const newValidation = {
      ...validation,
      [name]: '',
    };
    setValidation(newValidation);
  };

  const handleToggle = () => {
    setShowPassword(!isShowPassword);
  };

  const handleFormLabelOnClick = (name) => {
    const inputEle = document.getElementsByName(name)[0];

    if (inputEle) {
      inputEle.focus();
    }
  };

  return (
    <FormGroupStyled>
      <FormLabel onClick={() => handleFormLabelOnClick(field.name)}>
        {t(field.label)}
        <span>*</span>
      </FormLabel>
      <FormControl
        type={isShowPassword ? 'text' : field.type}
        name={field.name}
        placeholder={t(field.placeholder)}
        isInvalid={validation[field.name]}
        onChange={handleOnChange}
        onFocus={handleOnFocus}
      />
      <ShowHideIcon
        src={isShowPassword ? ShowIcon : HiddenIcon}
        width={24}
        height={24}
        alt=""
        onClick={handleToggle}
      />
      <FormControlFeedback hidden={false} type="invalid">
        {t(validation[field.name])}
      </FormControlFeedback>
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-grey-dark);

  span {
    color: var(--c-required);
  }
`;
const FormControl = styled(Form.Control)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-grey-dark);
  height: 44px;
  border: 1px solid var(--ds-c-grey-light);
  border-radius: 12px;
  padding-inline: 10px;
  background: var(--ds-c-white);

  &:focus {
    border: 1px solid var(--ds-c-grey-dark);
    outline: none;
    box-shadow: none;
  }

  &:invalid,
  &:invalid:focus,
  &.is-invalid {
    border: 1px solid var(--ds-c-red) !important;
    outline: none;
    box-shadow: none !important;
    background-image: none;
  }

  &::placeholder {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    color: var(--ds-c-blue-disabled) !important;
  }
`;
const FormControlFeedback = styled(Form.Control.Feedback)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  color: var(--ds-c-red);
  position: absolute;
  margin-top: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

const ShowHideIcon = styled.img`
  position: absolute;
  right: 8px;
  top: 40px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  background-color: transparent;
`;

export default FormInputValidation;
